import {FaCalendarAlt, FaCar, FaChartLine, FaPhoneAlt, FaShareSquare} from "react-icons/fa";
import {FaBookBookmark, FaClockRotateLeft, FaGears} from "react-icons/fa6";
import {PermissionEnum} from "../../../utils/enums/permission-enum.js";

const DispatchMenu = {
    "menu": [
        {
            "name": "CAD",
            "permissions": [PermissionEnum.DISPATCH],
            "url": "despacho/dashboard",
            "icon": "sw-dashboard-shield",
            "image": true,
            "id": "dashboard",
            "hideMenu": true
        },
        {
            "name": "Atendimentos",
            "permissions": [PermissionEnum.ATTENDANCE_WEB, PermissionEnum.ATTENDANCE_VISUALIZATION],
            "url": "despacho/attendance",
            "icon": FaPhoneAlt,
            "id": "attendance"
        },
        {
            "name": "Guarnições",
            "permissions": [PermissionEnum.GARRISON_WEB, PermissionEnum.MY_GARRISON, PermissionEnum.RETROACTIVE],
            "url": "#",
            "icon": FaCar,
            "id": "garrison",
            items: [
                {
                    "name": "Informações das guarnições",
                    "permissions": [PermissionEnum.ATTENDANCE_SCHEDULE],
                    "url": "despacho/garrison",
                    "id": "garrison"
                },
                {
                    "name": "Linha do tempo da guarnição",
                    "permissions": [PermissionEnum.GARRISON_TIMELINE],
                    "url": "despacho/garrison-timeline",
                    "id": "garrison-timeline"
                },
            ]
        },
        {
            "name": "Despachos",
            "permissions": [PermissionEnum.DISPATCH_DISPATCH, PermissionEnum.RETROACTIVE],
            "url": "despacho/dispatch",
            "icon": FaShareSquare,
            "id": "dispatch"
        },
        {
            "name": "Planejamento",
            "permissions": [PermissionEnum.ATTENDANCE_SCHEDULE, PermissionEnum.GARRISON_SCHEDULE, PermissionEnum.ATTENDANCE_SCHEDULE_CALENDAR],
            "url": "#",
            "icon": FaCalendarAlt,
            "id": "planning",
            "items": [
                {
                    "name": "Agendamento",
                    "permissions": [PermissionEnum.ATTENDANCE_SCHEDULE],
                    "url": "despacho/schedule-attendance",
                    "id": "schedule-attendance"
                },
                {
                    "name": "Calendário de agendamento",
                    "permissions": [PermissionEnum.ATTENDANCE_SCHEDULE_CALENDAR],
                    "url": "despacho/schedule-attendance-calendar",
                    "id": "schedule-attendance-calendar",
                    "hideMenu": true
                },
                {
                    "name": "Atividades programadas",
                    "permissions": [PermissionEnum.GARRISON_SCHEDULE],
                    "url": "despacho/schedule-garrison",
                    "id": "schedule-garrison"
                }
            ]
        },
        {
            "name": "Retroativo",
            "permissions": [PermissionEnum.RETROACTIVE],
            "url": "#",
            "icon": FaClockRotateLeft,
            "id": "retroactive",
            "items": [
                {
                    "name": "Guarnições",
                    "permissions": [PermissionEnum.RETROACTIVE],
                    "url": "despacho/garrison/retroactive",
                    "id": "garrison-retroactive"
                },
                {
                    "name": "Despachos",
                    "permissions": [PermissionEnum.RETROACTIVE],
                    "url": "despacho/dispatch/retroactive",
                    "id": "dispatch-retroactive"
                }
            ]
        },
        {
            "name": "Diário de plantão",
            "permissions": [PermissionEnum.DISPATCH_ACTIVITY, PermissionEnum.DISPATCH_ACTIVITY_SUBORDINATES],
            "url": "despacho/activity",
            "icon": FaBookBookmark,
            "id": "activity"
        },
        {
            "name": "Informações do plantão",
            "permissions": [PermissionEnum.DUTY_INFORMATION],
            "url": "despacho/duty-information",
            "icon": FaChartLine,
            "id": "duty-information",
            "hideMenu": true
        },
        {
            "name": "Configurações",
            "id": "configuration",
            "permissions": [PermissionEnum.DISPATCH_ADMIN],
            "icon": FaGears,
            "url": "#",
            "items": [
                {
                    "name": "Canais de atendimento",
                    "permissions": [PermissionEnum.DISPATCH_ADMIN],
                    "url": "despacho/attendance-channel",
                    "id": "attendance-channel"
                },
                {
                    "name": "Composições",
                    "permissions": [PermissionEnum.DISPATCH_ADMIN],
                    "url": "despacho/composition",
                    "id": "composition"
                },
                {
                    "name": "Prioridades",
                    "permissions": [PermissionEnum.DISPATCH_ADMIN],
                    "url": "despacho/priority",
                    "id": "priority"
                },
                {
                    "name": "Providências",
                    "permissions": [PermissionEnum.DISPATCH_ADMIN],
                    "url": "despacho/providence",
                    "id": "providence"
                },
                {
                    "name": "Status de atendimento",
                    "permissions": [PermissionEnum.DISPATCH_ADMIN],
                    "url": "despacho/attendance-status",
                    "id": "attendance-status"
                },
                {
                    "name": "Motivo da reserva de imagem",
                    "permissions": [PermissionEnum.DISPATCH_ADMIN],
                    "url": "despacho/reservation-cause",
                    "id": "reservation-cause"
                },
                {
                    "name": "Vistoria de posto fixo",
                    "permissions": [PermissionEnum.DISPATCH_ADMIN],
                    "url": "despacho/fixed-location-inspection",
                    "id": "fixed-location-inspection"
                }
            ]
        }
    ]
}

export default DispatchMenu;